import React from 'react';
import ReactDOM from 'react-dom/client';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import App from './App';
import { loadConfig, getMsalConfig } from './auth/authConfig';
import './index.css';

// Initialize the app
const initApp = async () => {
  // Load configuration from config.json
  await loadConfig();

  // Initialize MSAL
  const msalConfig = getMsalConfig();
  const msalInstance = new PublicClientApplication(msalConfig);
  await msalInstance.initialize();

  // Render the app
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>
  );
};

initApp().catch((error) => {
  console.error('Failed to initialize application:', error);
  document.getElementById('root')!.innerHTML = `
    <div style="padding: 20px; font-family: sans-serif;">
      <h1>Application Error</h1>
      <p>Failed to initialize the application. Please check the console for details.</p>
    </div>
  `;
});
